class AddressController {
  static get $inject() {
    return ['ogsdk.addressService'];
  }

  constructor(addressService) {
    this.addressService = addressService;
  }

  $postLink() {
    this.loading = true;
    return this.addressService.get(this.addressId).then((address) => {
      this.address = address;

      return address;
    }).finally(() => {
      this.loading = false;
    });
  }
}

module.exports = AddressController;

angular.module('msi.addresses')
  .controller('AddressController', AddressController);
